import { weenatIntl as wintl } from '@weenat/wintl';
import { CapacitiveEquation } from '../../resources/plots';
const useCapacitiveEquationsOptions = () => {
    const keys = Object.keys(CapacitiveEquation).filter((key) => isNaN(Number(key)));
    let irrigationTypeOptions = [];
    irrigationTypeOptions = keys.map((key) => {
        return {
            label: wintl.t(`capacitive_equations.${key}`, { capitalize: true }),
            value: CapacitiveEquation[key]
        };
    });
    return irrigationTypeOptions;
};
export default useCapacitiveEquationsOptions;
